import { compareAsc } from 'date-fns'
import { parseDate } from '../parseDate'

/**
 * Sort by createdAt asc
 *
 * @param a: { createdAt: string | Date }
 * @param b: { createdAt: string | Date }
 * @returns number
 *
 * @example
 * const data = [
 *  { createdAt: new Date('2021-01-01') },
 *  { createdAt: new Date('2021-01-03') },
 *  { createdAt: new Date('2021-01-02') },
 * ]
 *
 * data.sort(sortByCreatedAtAsc)
 * // => [
 * //   { createdAt: new Date('2021-01-01') },
 * //   { createdAt: new Date('2021-01-02') },
 * //   { createdAt: new Date('2021-01-03') },
 * // ]
 */
const sortByCreatedAtAsc = (a: { createdAt: string | Date }, b: { createdAt: string | Date }): number => {
  if (typeof a.createdAt === 'string' && typeof b.createdAt === 'string') {
    const [aCreatedAt, bCreatedAt] = [a.createdAt, b.createdAt].map(parseDate)

    if (aCreatedAt === null || bCreatedAt === null) {
      throw new Error(`Invalid createdAt string: a.createdAt: ${a.createdAt}, b.createdAt: ${b.createdAt}`)
    }

    return compareAsc(aCreatedAt, bCreatedAt)
  } else if (a.createdAt instanceof Date && b.createdAt instanceof Date) {
    return compareAsc(a.createdAt, b.createdAt)
  } else {
    throw new Error(`Invalid createdAt type: a.createdAt: ${a.createdAt}, b.createdAt: ${b.createdAt}`)
  }
}

export { sortByCreatedAtAsc }
